
import { Vue } from 'vue-class-component';
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus';
import CreateRoleModel from '@/models/roles/createRoleModel';
import router from '@/router';
import CurrentUserService from '@/services/currentUserService';
import ErrorCode from '@/constants/ErrorCode';
import * as accountTypeCode from '@/assets/data/accountTypeCode.json';
import RoleService from '../services/roleService';
import AccessRight from '../models/roles/accessRight';
import EnumDesription from '../constants/EnumDesription';

export default class Role extends Vue {
  private accountTypes = (accountTypeCode as any).default;

  private isCreate = false;

  private readonly userInfo = CurrentUserService.GetUserInfo();

  private roleList = [];

  private accessRightList: Array<AccessRight> = [];

  private dialogVisible = false;

  private name = '';

  private accountType=-1;

  private page = 1;

  private size = 10;

  private total = 0;

  private createRole = new CreateRoleModel();

  private rules = {
    name: [{
      required: true, whitespace: true, message: '请输入角色名', trigger: 'blur',
    }],
    accountType: [
      { required: true, message: '请选择角色类型', trigger: 'change' },
    ],
    accessRightCodes: [
      { required: true, message: '请选择权限', trigger: 'change' },
    ],
  };

  get createAccountType():any {
    return this.accountTypes.filter((it:any) => it.value >= 0);
  }

  mounted(): void {
    this.loadData();
    this.loadAccessRight();
  }

  async loadAccessRight(): Promise<void> {
    RoleService.getAccessRight().then((response) => {
      if (response.code === ErrorCode.Success) {
        this.accessRightList = response.data;
      }
    });
  }

  getAccessType(value: number): string {
    return EnumDesription.getAccountTypeDescription(value);
  }

  loadData(): void {
    RoleService.getPageAll(this.page, this.size, this.accountType, this.name)
      .then((result) => {
        if (result.code === ErrorCode.Success) {
          this.roleList = result.data.data;
          this.total = result.data.total;
        }
      })
      .catch((response) => {
        console.log(response);
      });
  }

  pageChange(currentPage: number): void {
    this.page = currentPage;
    this.loadData();
  }

  del(id: string, name: string): void {
    const msg = `你确定要删除【${name}】角色?`;
    ElMessageBox.confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        RoleService.delete(id)
          .then((response) => {
            if (response.code === ErrorCode.Success) {
              ElMessage.success('删除成功!');
              this.loadData();
            } else {
              ElMessage.error(response.msg);
            }
          })
          .catch((response) => {
            ElMessage.error(response.msg);
          });
      });
  }

  save(): void {
    const form: any = this.$refs.createform;
    form.validate((valid: boolean) => {
      if (valid) {
        const loadingInstance = ElLoading.service({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        RoleService.create(this.createRole).then((response) => {
          loadingInstance.close();
          if (response.code === ErrorCode.Success) {
            ElMessage.success(response.msg);
            this.loadData();
            form.resetFields();
            this.dialogVisible = false;
          } else {
            ElMessage.error(response.msg);
          }
        });
      }
    });
  }

  updateStatus(id: string, isActive: boolean, name:string): void {
    const msg = `你确定要${isActive ? '启用' : '禁用'}【${name}】角色?`;
    ElMessageBox.confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        RoleService.updateStatus(id, isActive).then((response) => {
          if (response.code === ErrorCode.Success) {
            ElMessage.success(response.msg);
            this.loadData();
          } else {
            ElMessage.error(response.msg);
          }
        }).catch((err) => {
          console.error(err);
          if (err && err.msg) { ElMessage.error(err.msg); } else {
            ElMessage.error('未知错误');
          }
        });
      });
  }

  opendetail(id: string): void {
    router.push({ path: `/role/${id}` });
  }
}
